import { render, staticRenderFns } from "./DiscussionArticle.vue?vue&type=template&id=12cf5469&scoped=true&"
import script from "./DiscussionArticle.vue?vue&type=script&lang=js&"
export * from "./DiscussionArticle.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionArticle.vue?vue&type=style&index=0&id=12cf5469&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cf5469",
  null
  
)

export default component.exports